import { render, staticRenderFns } from "./PublicWidgetSupporter.vue?vue&type=template&id=225cba30&scoped=true"
import script from "./PublicWidgetSupporter.vue?vue&type=script&lang=js"
export * from "./PublicWidgetSupporter.vue?vue&type=script&lang=js"
import style0 from "./PublicWidgetSupporter.vue?vue&type=style&index=0&id=225cba30&prod&lang=scss&scoped=true"
import style1 from "./PublicWidgetSupporter.vue?vue&type=style&index=1&id=225cba30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cba30",
  null
  
)

export default component.exports